export default __webpack_public_path__ + "static/media/bg_purple_middle.3e87895d.png";